import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';

import { RecordingsService } from './recordings.service';
import { ModalsService, ConfirmableActions } from './modals.service';

declare var AccountKit: any;

@Injectable()
export class AuthentificationService {
  constructor(
    private http: HttpClient,
    private fireAuth: AngularFireAuth,
    private recordingsDB: RecordingsService,
    private modals: ModalsService,
    private router: Router,
  ) {}

  startAuthorization() {
    // --------- Try to get data from local storage ---------
    const authData = JSON.parse(localStorage.getItem('authData'));
    if (authData) {
      this.firebaseAuth(authData.firebaseToken);
      this.recordingsDB.setUserId(authData.id);
      sessionStorage.setItem('authData', JSON.stringify(authData));
    } else { // --------- Procced manually---------
      this.facebookSmsLogin();
    }
  }

  maintainUserSession(): boolean {
    const authData = JSON.parse(sessionStorage.getItem('authData'));
    let resp: boolean;

    if (authData) {
      this.recordingsDB.setUserId(authData.id);
      resp = true;
    } else {
      if (this.router.url !== '/Login') {
        this.router.navigate(['Login']);
        resp = false;
      }
    }
    return resp;
  }

  // First step
  private facebookSmsLogin() {
    /* const countryCode = '+972';
    const phoneNumber = '534443666'; */
    const countryCode = '';
    const phoneNumber = '';
    AccountKit.login(
      'PHONE',
      { countryCode, phoneNumber },
      this.facebookCallback
    );
  }

  private facebookCallback = (response) => {
    if (response.status === 'PARTIALLY_AUTHENTICATED') {
      this.modals.openLoadingScreen();
      this.reqForFRBStoken(response.code);
    } else if (response.status === 'NOT_AUTHENTICATED') {
      console.log('Facebook modal closed');
    } else if (response.status === 'BAD_PARAMS') {
      console.error(response.status);
      this.modals.closeLoadingScreen();
      this.modals.openWarning(
        'Could not authintificate in facebook',
        'Try again or Send error from the console(f12) to administrator, please',
        ConfirmableActions.None
      );
    }
  }

  // Second step
  private reqForFRBStoken = (code) => {
    const request = 'code=' + code + '&state=YANIV';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.http.post<ScdResponse>('https://supercallrecorderapp.com/authentication_fb.php', request, httpOptions).toPromise()
      .then(authData => {
        // console.log(authData);
        localStorage.setItem('authData', JSON.stringify(authData));
        sessionStorage.setItem('authData', JSON.stringify(authData));
        this.recordingsDB.setUserId(authData.id);
        this.firebaseAuth(authData.firebaseToken);
      })
      .catch(err => {
        console.error(err);
        this.modals.closeLoadingScreen();
        this.modals.openWarning('Token server error', 'Send error from the console(f12) to administrator, please', ConfirmableActions.None);
      });
  }

  // Third step
  private firebaseAuth(token: string) {
    this.fireAuth.auth.signInWithCustomToken(token)
      .then(resp => {
        this.modals.closeLoadingScreen();
        this.router.navigate(['MyRecordings']);
      })
      .catch(error => {
        let modalHeader: string;
        let modalReason: string;

        this.logout();
        console.error(error);
        if (error.code === 'auth/invalid-custom-token') {
          console.clear();
          this.facebookSmsLogin();
        } else {
          modalHeader = 'Database server error';
          modalReason = 'Send error from the console(f12) to administrator, please';
          this.modals.openWarning(modalHeader, modalReason, ConfirmableActions.None);
        }
      });
  }


  logout() {
    localStorage.removeItem('authData');
    sessionStorage.removeItem('authData');
    this.router.navigate(['Login']);
  }
}


interface ScdResponse {
  accessToken: string;
  expirationInSec: number;
  firebaseToken: string;
  id: string;
  phoneNumber: string;
}

const respo = {
  // tslint:disable-next-line:max-line-length
  accessToken: 'EMAWeecIztu2F4n9F3jT57k1JNZC7dFlhISM5lJeyW9ZCT2AAZBaAZA5cN2aSuSe18unrrxhqTKEkCh2kDk0EmrvdChOVB8wdZCKWoLlKzLU3pI82ntYmSr5DlFb8rio7st99PmvYVYNWjm3oyuSeWZA6MMlllYEpxcZD',
  expirationInSec: 2592000,
  // tslint:disable-next-line:max-line-length
  firebaseToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJmaXJlYmFzZS1hZG1pbnNkay1iOHBtMEBpb3MtY2FsbC1yZWNvcmRlci5pYW0uZ3NlcnZpY2VhY2NvdW50LmNvbSIsInN1YiI6ImZpcmViYXNlLWFkbWluc2RrLWI4cG0wQGlvcy1jYWxsLXJlY29yZGVyLmlhbS5nc2VydmljZWFjY291bnQuY29tIiwiYXVkIjoiaHR0cHM6XC9cL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbVwvZ29vZ2xlLmlkZW50aXR5LmlkZW50aXR5dG9vbGtpdC52MS5JZGVudGl0eVRvb2xraXQiLCJpYXQiOjE1MjUzMjkxMjgsImV4cCI6MTUyNTMzMjcyOCwidWlkIjoiMTQzNzc2MDgyMjk1NzAxOCIsImNsYWltcyI6eyJwcmVtaXVtX2FjY291bnQiOnRydWUsInBob25lTnVtYmVyIjoiKzk3MjUzNDQ0MzY2NiJ9fQ.pL7UuvjRQvFX1yBYQO_tH0R8cBghzuSFSpH97ErsQk4BV3OUPXp3MALoQ2TIAO46NMaRwgu6DEq_oHXqMZ9HBcdxRd7A-sEI5fuqVgmDv1ypF6EcPCry5bq1nflCbNpy3-F3vHr2zt3_21-MuCBXaJJaO7a38FITmEzykLgTO6ticiXPd2CFg4e3YJwMYpxSp6lvhtDJ5IZ7rY3YWcGYP8tQz-qHc_QNu-Kcn_4yNUissOA5zZKZyqVMrsms6mYsJlg8wyc_zfw67ojDHv_vdwd-m0qJv3-28Oe3UlRB5dXyzrI9aP3kUuJ3ygpdMYvsRvtQZ16Snm6e87z5b_-8FQ',
  id: '1437760822957018',
  phoneNumber : '+972534443666',
};

// firebase:host:ios-call-recorder.firebaseio.com 's-usc1c-nss-257.firebaseio.com'




// WEBPACK FOOTER //
// ./src/app/services/authentification.service.ts